import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Auth from './Auth'; // <-- THE LIFESAVER IMPORT
import { Helmet } from 'react-helmet-async'; // 👈 THE SEO IMPORT

function AdonisianCreed() {
  const [glitch, setGlitch] = useState(false);

  // Scroll to top on load AND handle the matrix glitch effect
  useEffect(() => {
    window.scrollTo(0, 0); // <-- FIXES THE SCROLL BUG

    const interval = setInterval(() => {
      setGlitch(true);
      setTimeout(() => setGlitch(false), 150);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const asciiRabbit = `
        Wake up.
        The matrix has you.
        Follow the white rabbit.
        
        (\\_(\\ 
        (=' :') 
        (,(")(") 
          ...into the quantum void.
  - - - - - - - - - - - - - - -
   \\ | /      |      \\ | /
 - - o - -  010101  - - o - - 
   / | \\      |      / | \\
  `;

const linkStyle = { 
  color: '#0d1117', 
  backgroundColor: '#ffca28', 
  padding: '10px 20px', 
  borderRadius: '4px', 
  textDecoration: 'none', 
  marginTop: '40px', 
  display: 'inline-block', 
  fontWeight: 'bold', 
  letterSpacing: '1px' 
};

  return (

  <div style={{
      backgroundColor: '#000000',
      minHeight: '100vh',
      height: 'auto',              // <-- Keeps scrolling unlocked
      width: '100%',               // <-- Prevents side-scrolling
      overflowY: 'auto',           // <-- Mobile scroll fix
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: '"Courier New", Courier, monospace', 
      color: '#00ff41', 
      padding: '2rem 1rem',        // <-- Mobile padding
      boxSizing: 'border-box'
    }}>
      
      {/* 👇 THE CREED SEO SHIELD 👇 */}
      <Helmet>
        <title>The Adonisian Creed | Escape the Astrological Simulation</title>
        <meta name="description" content="Your astrological identity is a lie. Read the Adonisian Creed and awaken to the true 33-level spinal matrix and the physical reality of the cosmos." />
      </Helmet>
      
      {/* --- ASCII WHITE RABBIT --- */}
      <pre style={{
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
        fontSize: '1rem',
        lineHeight: '1.2',
        marginBottom: '40px',
        textShadow: glitch ? '2px 0 red, -2px 0 blue' : '0 0 5px #00ff41'
      }}>
        {asciiRabbit}
      </pre>

      {/* --- THE CREED --- */}
      <div style={{
        maxWidth: '600px',
        width: '100%',
        textAlign: 'left',
        background: 'rgba(0, 255, 65, 0.05)',
        border: '1px solid #00ff41',
        padding: '30px',
        boxSizing: 'border-box',
        boxShadow: '0 0 15px rgba(0, 255, 65, 0.2)'
      }}>
        <h2 style={{ 
          fontSize: '1.8rem', 
          textTransform: 'uppercase', 
          borderBottom: '1px dashed #00ff41', 
          paddingBottom: '10px',
          marginBottom: '25px',
          color: '#ffffff'
        }}>
          &gt; Adonisian_Creed.exe
        </h2>
        
        <p style={{ lineHeight: '1.8', fontSize: '1.1rem', margin: '0 0 15px 0' }}>
          I am the harmonization of contradictions,<br/>
          The indivisible oneness,<br/>
          The miraculous mindset that undoes the fear of the world.
        </p>
        
        <p style={{ lineHeight: '1.8', fontSize: '1.1rem', margin: '0 0 15px 0' }}>
          I absorb all the details and <br/>
          I fixate the focus of my attention<br/>
          To see the space in-between is where SPIRIT is.
        </p>
        
        <p style={{ lineHeight: '1.8', fontSize: '1.1rem', margin: '0 0 15px 0' }}>
          I live framelessly, surrendering my ego<br/>
          For my higher-will be done through me.<br/>
          Imagining, in order, to CO-CREATE in the quantum NOW<br/>
          For future is always future, like<br/>
          Past is always past,<br/>
          Both are always unreal. 
        </p>
        
        <p style={{ lineHeight: '1.8', fontSize: '1.1rem', margin: '0 0 15px 0', color: '#ffffff', fontWeight: 'bold' }}>
          Only the ETERNITY of the present quantum moment is real. 
        </p>
        
        <p style={{ lineHeight: '1.8', fontSize: '1.1rem', margin: '0 0 15px 0' }}>
          For there is enough time to <br/>
          Forgive everything as it comes, in order, <br/>
          To say aligned with the abundance and <br/>
          Prosperity of the PRESENT moment with<br/>
          Impeccable readiness.
        </p>
        
        <p style={{ lineHeight: '1.8', fontSize: '1.1rem', margin: '0 0 0 0' }}>
          For the miracles and the healing of SOURCE<br/>
          Are in the eternal and INFINITE,<br/>
          Spaceless and timeless, <br/>
          Multidimensional present moment of the<br/>
          QUANTUM here and now. 🕳️🐇 
        </p>
<style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
          
          /* Matrix Button Override targeting the Auth Component */
          .matrix-gate-container button {
            background-color: #00ff41 !important;
            color: #000000 !important;
            border: none !important;
            box-shadow: 0 0 10px rgba(0, 255, 65, 0.4) !important;
            font-weight: bold !important;
            text-transform: uppercase !important;
            transition: all 0.3s ease !important;
          }
          
          .matrix-gate-container button:hover {
            background-color: #ffffff !important;
            box-shadow: 0 0 20px rgba(0, 255, 65, 0.8) !important;
          }
        `}
      </style>      
      </div>

      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
        `}
      </style>

      <div className="matrix-gate-container" style={{ 
        width: '100%', 
        maxWidth: '600px', 
        margin: '50px auto 20px auto', 
        padding: '30px', 
        boxSizing: 'border-box', /* <-- THIS PREVENTS THE RIGHT-SIDE BLEED */
        background: 'rgba(0, 255, 65, 0.02)', 
        border: '1px solid #00ff41', 
        borderRadius: '4px', 
        textAlign: 'center', 
        boxShadow: '0 0 15px rgba(0, 255, 65, 0.1)' 
      }}>
        <h2 style={{ color: '#00ff41', fontSize: '1.6rem', fontFamily: 'monospace', letterSpacing: '2px' }}>[ ESCAPE THE SIMULATION ]</h2>
        
        <p style={{ color: '#8b949e', fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '25px', fontFamily: 'sans-serif' }}>
          The systems of the 2nd century are holding your biometric capacity hostage. Initialize your true coordinates.
        </p>
        
        {/* CHANGED COLOR TO #00ff41 */}
        <h3 style={{ color: '#00ff41', marginBottom: '15px', fontSize: '1.1rem', letterSpacing: '1px' }}>INITIALIZE ASCENDANCE PROTOCOL</h3>
        
        <div style={{ maxWidth: '350px', margin: '0 auto', background: '#05070a', padding: '20px', borderRadius: '4px', border: '1px solid #00ff41', boxSizing: 'border-box' }}>
          <Auth />
        </div>
      </div>

     <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
        <Link to="/" style={linkStyle}>The Portal 📟</Link>
      </div>
    </div>
  );
}

export default AdonisianCreed;